/**
 * A library for working with verifiable credentials - vc-js library.
 *
 * @author David I. Lehn
 *
 * Copyright 2017-2020 Digital Bazaar, Inc.
 */
module.exports = require('./vc.js');
